import React from 'react';
import { TestId } from '@components/test-ids';
import { SkeletonElement, SkeletonInlineWrapper, SkeletonVariant } from '@components/common/skeleton-loading';
import {
  Container,
  ContentContainer,
  IntroContainer,
  DestinationLabel,
  TourNameLabel,
  PriceRow,
  PricingContainer
} from './TourDealFinderTile';

/* ****************************** *
 *    TourGhostTile    *
 * ***************************** */

export const TourGhostTile = () => {
  return (
    <Container>
      <SkeletonElement variant={SkeletonVariant.RECTANGLE} width={'100%'} height={200} />
      <ContentContainer data-testid={TestId.dealFinder.tile.contentContainer}>
        <IntroContainer>
          <DestinationLabel data-testid={TestId.dealFinder.tile.destination}>
            <SkeletonElement variant={SkeletonVariant.TEXT} width={'20%'} />
          </DestinationLabel>
          <TourNameLabel data-testid={TestId.dealFinder.tile.hotel}>
            <SkeletonElement variant={SkeletonVariant.TEXT} width={'40%'} />
          </TourNameLabel>
          <SkeletonInlineWrapper>
            <SkeletonElement variant={SkeletonVariant.TEXT} width={100} inline />
            <SkeletonElement variant={SkeletonVariant.TEXT} width={100} inline />
            <SkeletonElement variant={SkeletonVariant.TEXT} width={100} inline />
          </SkeletonInlineWrapper>
        </IntroContainer>
        <PricingContainer>
          <PriceRow data-testid={TestId.dealFinder.tile.priceRow}>
            <SkeletonElement variant={SkeletonVariant.TEXT} width={'40%'} />
          </PriceRow>
        </PricingContainer>
      </ContentContainer>
    </Container>
  );
};
